import { Pipe, PipeTransform } from '@angular/core';
import { AddressDto } from '@fleet-beat/core';

@Pipe({
  name: 'companyAddress',
})
export class CompanyAddressPipe implements PipeTransform {
  transform(address: AddressDto): string {
    if (!address) {
      return '';
    }

    return [
      address.line2,
      address.line1,
      [address.stateAbbr || address.state, address.postal].filter(Boolean).join(' '),
    ]
      .filter(Boolean)
      .join(', ');
  }
}
